<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title">The Four Corners of the World</p>
<p class="authorname">A. E. W. Mason</p>
<p class="publisher"><span><img alt="logo1" class="svg" src="fig_logo.jpg"/></span></p>
<p class="publisher1"><span><a href="http://MYSTERIOUSPRESS.COM" target="_blank">MYSTERIOUSPRESS.COM</a></span></p>
<p class="publisher1"><span><img alt="logo" class="svg" src="logo.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_000.vue?aad8bf08